<template>
    <div class="new-landing-page" v-if="isShow">
        <swiper v-if="sliderList.length" id="landing-swiper">
            <swiper-slider v-for="(item, idx) in sliderList" :key="idx">
                <div
                    @click="checkJump(item, 'banner')"
                    class="banner-item"
                    :style="{
                        background: `url(${item.background_img_url})`,
                        'background-size': 'contain'
                    }">
                        <template v-if="item.type === 'torch'">
                            <div class="item-title font-48">{{item.title}}</div>
                            <!-- <div class="item-reward font-60">{{item.reward}}</div> -->
                        </template>
                        <template v-else>
                            <div class="item-title font-48">{{item.title}}</div>
                            <!-- <div class="item-title font-48">{{item.sub_title}}</div> -->
                        </template>
                    </div>
            </swiper-slider>
        </swiper>
        <div class="landing-con" :class="sliderList.length ? 'has-banner' : ''">
            <div class="referrer-con font-28 box-shadow" v-if="dgdBanner.title && channel === '28'">
                <div class="referrer-img" :style="{background: `url(${dgdBanner.icon_url})`, 'background-size': 'cover'}"></div>
                {{dgdBanner.title}}
            </div>
            <div class="tel-con box-shadow" :class="dgdBanner.title && channel === '28' ? 'has-referrer' : ''">
                <div class="font-28">
                    <DrawerLandingCity :imgUrl="citySelect.icon_url" @changeCity="getPageConf" :omegaItem="omegaItem" />
                </div>
                <div class="phone-input">
                    <div class="font-36">{{phoneCountryCode}}</div>
                    <input
                        ref="phone_input"
                        autocomplete="off"
                        type="tel"
                        maxlength="100"
                        v-model="phone"
                        @input="formatCell"
                        :placeholder="$t('GDriver_optimize_Mobile_number_TfWK')"
                    />
                </div>
                <div class="select-wrapper" v-if="identitySelect && isWhatsApp" @click="selectClick">
                    <cube-select
                        v-model="identitySelect.value"
                        :title="identitySelect.title"
                        :options="identitySelect.identity_options"
                        :placeholder="identitySelect.placeholder || identitySelect.title"
                        :confirmTxt="$t('确认')"
                        :cancelTxt="$t('取消')"
                        @change="changeSelect"
                    >
                    </cube-select>
                </div>
                <div class="font-28" :style="{color: helpLink.color}">
                    <span @click="checkJump(helpLink, 'help')">{{helpLink.title}}</span>
                </div>
            </div>
            <div
                :style="{
                    background: item.background_img_url ? `url(${item.background_img_url})` : '',
                    'background-size': 'cover'
                }"
                class="pro-area-item box-shadow"
                :class="'item-' + item.type"
                v-for="(item, itemInd) in propagandaArea"
                :key="item.title + itemInd">
                <div class="title">
                        <div
                            class="tit-icon"
                            :style="{
                                background: `url(${item.title_icon})`,
                                'background-size': 'cover'
                            }">
                        </div>
                        <div class="tit-text">{{item.title}}</div>
                        <div
                            class="tit-icon"
                            :style="{
                                background: `url(${item.title_icon})`,
                                'background-size': 'cover'
                            }">
                        </div>
                    </div>
                <template v-if="['safety', 'income'].includes(item.type)">
                    <div class="it-con font-28" v-for="(it, itInd) in item.content" :key="it + itInd" v-html="it"></div>
                </template>
                <template v-if="item.type === 'why'">
                    <div class="why-item font-24" v-for="(it, itInd) in item.content" :key="it.title + itInd">
                        <div
                            class="bottom-icon"
                            :style="{
                                background: `url(${it.comma_buttom_img_url})`,
                                'background-size': 'cover'
                            }">
                        </div>
                        <div class="item-head" :style="{background: it.comma_up_background_color}">
                            <div
                                class="top-icon"
                                :style="{
                                    background: `url(${it.comma_up_img_url})`,
                                    'background-size': 'cover'
                                }">
                            </div>
                            <div
                                class="head-img"
                                :style="{
                                    background: `url(${it.portrait_icon_url})`,
                                    'background-size': 'cover'
                                }">
                            </div>
                            <div class="head-tit font-28">{{it.title}}</div>
                            <div class="head-sub-tit font-20">{{it.sub_title}}</div>
                        </div>
                        <div class="item-con" v-for="(con, conInd) in it.content" :key="con + conInd" v-html="con"></div>
                    </div>
                </template>
            </div>
            <div v-if="isWhatsApp && noWhatsApp.title" class="no-whatsapp font-24">
                <div class="tit">{{noWhatsApp.title}}</div>
                <div
                    @click="doLogin('urlClick')"
                    class="btn font-28"
                    :style="{
                        'border-color': noWhatsApp.button.text_color,
                        color: noWhatsApp.button.text_color
                    }">
                    <span>{{noWhatsApp.button.title}}</span>
                </div>
            </div>
            <div class="bottom-con font-36">
                <img-v3 v-if="bottomIcon.icon_url" :src="bottomIcon.icon_url" alt="" class="img" />
                {{bottomIcon.title}}
            </div>
        </div>
        <div class="page-foot font-28">
            <div class="foot-text">
                <img-v3
                    @click="changeCheck"
                    class="foot-check"
                    :src="btnTerms[`icon_${isCheck ? 'is' : 'un'}_check_url`]"
                    alt="icon_un_check_url" />
                <div>
                    <span>{{btnTerms.title}}</span>
                    <span
                        @click="checkJump(btnTerms)"
                        :style="{
                            color: btnTerms.link_title_color
                        }">
                        {{btnTerms.link_title}}
                    </span>
                </div>
            </div>
            <div
                @click="doLogin"
                :style="{
                    'background-color': isWhatsApp ? btnWhats.background_color : btnButton.background_color,
                    color: isWhatsApp ? btnWhats.text_color : btnButton.text_color
                }"
                class="foot-btn font-36">
                {{isWhatsApp ? btnWhats.title : btnButton.title}}
            </div>
        </div>
    </div>
</template>
<script>
import { showLoadingToast, showToast, showDialog } from "../../tools/Tip";
import { Swiper, SwiperSlider } from "../base/Swiper";
import { post, get } from "../../tools/request";
import { LOGIN_CONFIG, ends } from "../../tools/constant";
import { mapMutations, mapState } from "vuex";
import DrawerLandingCity from "../base/drawer-landing-city.vue";
import { getEnd } from "../../tools/utils";

export default {
    name: 'newLandingPage',
    components: {
        Swiper,
        SwiperSlider,
        DrawerLandingCity
    },
    data() {
        return {
            configData: {},
            phone: '',
            isCheck: false,
            sliderList: [],
            dgdBanner: {},
            citySelect: {},
            helpLink: {},
            propagandaArea: [],
            noWhatsApp: {},
            bottomIcon: {},
            btnTerms: {},
            btnButton: {},
            btnWhats: {},
            identitySelect: null,
            isShow: false,
            identity: 3,
        };
    },
    computed: {
        ...mapState([
            "_ticket",
            "_area",
            "_mx_landingpage_wa_0302",
            "_open_type",
        ]),
        country() {
            return this.params.get("location_country");
        },
        oasis() {
            return this.params.get("business_line") === "oasis";
        },
        params() {
            return new URLSearchParams(location.search);
        },
        phoneCountryCode() {
            return LOGIN_CONFIG[this.country].country_calling_code;
        },
        isWhatsApp() {
            return this.params.get("end") === "WhatsappEnd" || this.params.get('from_end') === 'WhatsappConf';
        },
        channel() {
            return this.params.get("channel");
        },
        bis_id() {
            return this.params.get("bis_id");
        },
        oid() {
            return this.params.get("oid") || Omega.getOmgid()
        },
        omegaItem() {
            return {
                bis_id: this.bis_id || '',
                channel: this.channel || '',
                end: getEnd(),
                oid: this.oid,
                whatsapp: this.isWhatsApp ? +this.isWhatsApp : 0,
                city_id: this._area.value || '',
                country_code: this.phoneCountryCode,
                a: this.params.get("a") || '', // dgd活动id
                scene: this.params.get("scene") || '', // 新旧dgd
                i: this.params.get("i") || '', // 推荐人ID-加密后的
            }
        }
    },
    mounted() {
        try {
            Omega.trackEvent("ibt_onboarding_displaylandingpage_sw", "", {
                ...this.omegaItem,
                client_user_agent: navigator.userAgent, // 必须
                fbp: this.$cookies.get('_fbp'), // 可选，可能有多个，需要和domain匹配
                fbc: this.$cookies.get('_fbc'), // 可选，可能有多个或没有，需要和domain匹配
            });
            gtm({
                'event': 'pageview',
                'error': 'false'
            })
        } catch (e) {}

        window.addEventListener("scroll", this.monitorScroll, true);

        if (this._area.value) {
            this.getPageConf();
        } else {
            this.getLocation();
        }
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.monitorScroll, true);
    },
    methods: {
        ...mapMutations(["setState"]),
        monitorScroll() {
            let marginBot = 0;
            if (document.compatMode === 'CSS1Compat') {
                marginBot = document.documentElement.scrollHeight - (document.documentElement.scrollTop+document.body.scrollTop) -  document.documentElement.clientHeight;
            } else {
                marginBot = document.body.scrollHeight - document.body.scrollTop - document.body.clientHeight;
            }
            if (marginBot <= 0) {
                Omega.trackEvent("ibt_onboarding_landingpageslidebottom_sw", "", this.omegaItem);
            }
        },
        doLogin(clickType) {
            // @20220117 补齐广告埋点
            try {
                Omega.trackEvent("ibt_onboarding_landingpageclicknext_ck", "", {
                    phone: this.phone,
                    ...this.omegaItem,
                    fbp: this.$cookies.get('_fbp'), // 可选，可能有多个，需要和domain匹配
                    fbc: this.$cookies.get('_fbc'), // 可选，可能有多个或没有，需要和domain匹配
                });
                gtm({
                    'event': 's1PassportRegister',
                    'PhoneNumber': 'invalid',
                    'Country': 'BR',
                    'RegisterWith': '99',
                    'error': 'false'
                })
            } catch (e) {}
            if (!this._area.value) {
                showToast(this, {
                    type: "warn",
                    txt: this.$t("GDriver_optimize_Please_choose_SJtI")
                });
                document.documentElement.scrollTop = 0;
                return;
            } else if (!this.phone) {
                showToast(this, {
                    type: "warn",
                    txt: this.$t("GDriver_optimize_Enter_the_Qnir")
                });
                document.documentElement.scrollTop = 0;
                this.$refs.phone_input.focus();
                return;
            } else if (!this.isCheck) {
                showToast(this, {
                    type: "warn",
                    txt: this.$t("GDriver_optimize_Read_and_xrQu")
                });
                return;
            }
            // @20220117 补齐广告埋点
            try {
                gtm({
                    'event': 's1PassportRegister',
                    'PhoneNumber': 'valid',
                    'Country': 'BR',
                    'RegisterWith': '99',
                    'error': 'false'
                })
            } catch (e) {}

            if (this.isWhatsApp && clickType !== 'urlClick') {
                showLoadingToast(this);
                let up = new URLSearchParams(location.search);
                up.set("countryCode", this.country);
                up.set("phone", this.phone);
                up.set(this._open_type, this._area.value);
                up.set("product", 2); // wa默认产品线2-快车
                up.set("identity", this.identity);
                post(this.btnWhats.link, up)
                .then(data => {
                    if (data) {
                        window.location.href = data;
                    }
                })
                .catch(err => {
                    Omega.trackError("tech_ibt_onboarding_landingpagegetwhatsapp_bt", err.errno, err.errmsg, {
                        url: this.btnWhats.link,
                        resp: err,
                        desc: 'new landingpage获取whatsapp接口'
                    });
                    console.log(err);
                    const { errno } = err;
                    if (+errno === 400001) {
                        showDialog(this, {
                            type: "confirm",
                            icon: "cubeic-info",
                            content: this.$t("GDriver_optimize_Phone_No_boYK").replace(/{{phone_number}}/, this.phone),
                            confirmBtn: {
                                text: this.$t("GDriver_optimize_Continue_KFSQ"),
                            },
                            cancelBtn: { text: this.$t("GDriver_optimize_Modify_Phone_Ovvv") },
                            onConfirm: () => {
                                this.checkPhone();
                            },
                            onCancel: () => {
                                this.$refs.phone_input.focus();
                            }
                        });
                    }
                })
                .finally(() => {
                    this.toast.hide();
                });

            } else {
                this.checkPhone();
            }
        },
        checkPhone() {
            showLoadingToast(this, this.$t("加载中"), 1500);
            document.documentElement.scrollTop = 0;
            login.checkPhone(
                this.phone,
                response => {
                    const { ticket, cell, uid } = response;
                    this.setState({ _ticket: ticket, _cell: cell, _uuid: uid });
                    let up = new URLSearchParams(location.search);
                    //兼容各个国家情况，vuex中如果存在ticket，则优先信任
                    if (this._ticket) {
                        up.set("ticket", this._ticket);
                    }
                    up.set("area_id", this._area.value);
                    post(process.env.SET_AREA_ID, up)
                        .then(data => {
                            const { errno, area_name } = data;
                            if (errno === 10090) {
                                showDialog(this, {
                                    type: "confirm",
                                    icon: "cubeic-info",
                                    content: area_name ? this.$t("GDriver_optimize_The_city_GkTr").replace(/{{city_name}}/, area_name) : this.$t("GDriver_optimize_You_have_eFId"),
                                    confirmBtn: {
                                        text: this.$t("GDriver_optimize_Determination_AIJf"),
                                    },
                                    cancelBtn: { text: this.$t("取消") },
                                    onConfirm: () => {
                                        this.$router.replace({ name: "home" });
                                    },
                                    onCancel: () => {
                                        this.$router.replace({ name: "home" });
                                    },
                                });
                            } else {
                                this.$router.replace({ name: "home" });
                            }
                        })
                        .catch(err => {
                            Omega.trackError("tech_ibt_onboarding_landingpagesetareaid_bt", err.errno, err.errmsg, {
                                url: process.env.SET_AREA_ID,
                                resp: err,
                                desc: 'new landingpage存储areaId报错'
                            });
                            console.log(err);
                        })
                },
                error => {
                    console.log(error);
                }
            );
        },
        checkJump({link_type, target, link}, itemType) {
            if (!link) {
                return false;
            }
            let up = '';
            if (itemType === 'banner') {
                Omega.trackEvent("ibt_onboarding_landingpageclickbanner_ck", "", this.omegaItem);
                up = new URLSearchParams(location.search);
                if (this._area.value && this._area.text) {
                    up.set("areaId", this._area.value);
                    up.set("areaName", this._area.text);
                }
            }
            if (itemType === 'help') {
                Omega.trackEvent("ibt_onboarding_landingpageclicktutorials_ck", "", this.omegaItem);
            }
            let _url = `${link}${link.includes('?') ? '&' : '?'}${up}`;

            if (link_type === 'blank' || target === 'blank') {
                if (ends.inApp) {
                    Fusion.openPage && Fusion.openPage({
                        url: _url,
                        newWindow: true
                    });
                } else {
                    window.open(_url);
                }
            } else {
                window.location.href = _url;
            }

        },
        getLocation() {
            showLoadingToast(this);
            this.isShow = false;
            let that = this;
            let up = new URLSearchParams(location.search);
            let lng = up.get("lng");
            let lat = up.get("lat");
            if (lat && lng) {
                this.getLocateCity(lng, lat);
            } else {
                /**
                 *  获取经纬度信息
                 *  position_option 获取经纬度信息的配置项
                 *  getPositionSuccess 信息获取成功函数
                 *  getPositionError 信息获取失败函数
                 */
                var position_option = {
                    enableHighAccuracy: true, //告诉浏览器是否启用高精度设备
                    maximumAge: 30000, //单位毫秒，告诉设备缓存时间，主要用于设备的省电或者节省带宽方面
                    timeout: 3000 //超时时间
                };
                navigator.geolocation.getCurrentPosition(
                    getPositionSuccess,
                    getPositionError,
                    position_option
                );
                function getPositionSuccess(position) {
                    that.getLocateCity(
                        position.coords.longitude,
                        position.coords.latitude
                    );
                }
                function getPositionError(e) {
                    that.getPageConf();
                    console.log(e);
                }
            }
        },
        getLocateCity(lng, lat) {
            showLoadingToast(this);
            this.isShow = false;
            let up = new URLSearchParams(location.search);
            //兼容各个国家情况，vuex中如果存在ticket，则优先信任
            if (this._ticket) {
                up.set("ticket", this._ticket);
            }
            if (!up.get("lng")) {
                up.set("lng", lng);
                up.set("lat", lat);
                // up.set("lng", '-46.633884'),
                // up.set('lat', '-23.545484')
            }
            post(process.env.LANDING_PAGE_GET_LOCATE_CITY, up)
                .then(data => {
                    this.setState({
                        _area: {
                            text: data.text,
                            value: data.value
                        },
                        _open_type: data.open_type
                    });
                    Omega.trackEvent("ibt_onboarding_landingpagecity_sw", "", this.omegaItem);
                    this.getPageConf();
                })
                .catch(err => {
                    this.getPageConf();
                    Omega.trackError("tech_ibt_onboarding_landingpagegetlocatecity_bt", err.errno, err.errmsg, {
                        url: process.env.LANDING_PAGE_GET_LOCATE_CITY,
                        resp: err,
                        desc: 'new landingpage获取当前城市报错'
                    });
                    console.log(err);
                });
        },
        formatCell() {
            this.phone = this.phone.replace(/\D/g, "");
        },
        changeCheck() {
            this.isCheck = !this.isCheck;
        },
        getPageConf() {
            showLoadingToast(this);
            this.isShow = false;
            let up = new URLSearchParams(location.search);
            //兼容各个国家情况，vuex中如果存在ticket，则优先信任
            if (this._ticket) {
                up.set("ticket", this._ticket);
            }
            up.set("area_id", this._area.value);
            post(process.env.LANDING_PAGE_GET_CONF, up)
                .then(data => {
                    const { resource_bit, phone_enter, propaganda_area, terms_button, no_whatsapp_text, buttom_icon } = data;
                    this.sliderList = resource_bit || [];
                    this.dgdBanner = phone_enter.dgd_banner || {};
                    this.citySelect = phone_enter.city_select || {};
                    this.helpLink = phone_enter.help_link || {};
                    this.propagandaArea = propaganda_area || [];
                    this.noWhatsApp = no_whatsapp_text || {};
                    this.bottomIcon = buttom_icon || {};
                    this.btnTerms = terms_button && terms_button.terms ? terms_button.terms : {};
                    this.btnButton = terms_button && terms_button.button ? terms_button.button : {};
                    this.btnWhats = terms_button && terms_button.whatsapp_button ? terms_button.whatsapp_button : {};
                    this.identitySelect = phone_enter.identity_select || null;
                    if (this.identitySelect) {
                        this.identity = this.identitySelect.value
                    }
                })
                .catch((err) => {
                    Omega.trackError("tech_ibt_onboarding_landingpagegetconf_bt", err.errno, err.errmsg, {
                        url: process.env.LANDING_PAGE_GET_CONF,
                        resp: err,
                        desc: 'new landingpage获取页面配置报错'
                    });
                    console.log(err);
                })
                .finally(() => {
                    this.$nextTick(() => {
                        this.toast.hide();
                        this.isShow = true;
                    });
                });
        },
        changeSelect(v) {
            this.identity = v
        },
        selectClick() {
            Omega.trackEvent("ibt_onboarding_landingpagerolechoice_ck", "", this.omegaItem);
        }
    }
};
</script>
<style lang="scss">
@import "../../css/new-landing-page.scss";
</style>
